export const getGlobalModalData = (configData: any, donationString: string) => {
  const {
    store: { name: storeName },
    causes: {
      featured: {
        name: causeName,
        charityName,
        charityLogo,
        charityBackground,
        charityImpactMessage,
        causeBackground,
      },
    },
    customization: {
      modal: { content: { globalBanner } },
    },
  } = configData;

  return {
    storeName: storeName,
    causeName: causeName,
    charityName: charityName,
    charityLogo: charityLogo,
    charityBackground: charityBackground,
    charityImpactMessage: charityImpactMessage,
    causeBackground: causeBackground,
    globalBanner: globalBanner,
    donationString: donationString
  };
};
